import React, {ReactNode} from 'react';

import {EyeExam, MyAccount, Rx} from '@optimaxdev/icons';

import {Price} from 'components/price/price';
import {PRESCRIPTION_STATUS, CL_RX_METHOD, VISIBLY_PRICE} from 'constants/success';

import {OrderDetailsItemsType} from 'types/orderDetailsTypes';
import {FILL_IT} from 'types/successPage';

export type PopupContentItemType = {
    methodName: string;
    title: ReactNode;
    description?: ReactNode;
    badge?: string;
    image?: any;
    ctaButtonText?: string;
    isLinkButton?: boolean;
    analyticsLabel?: string;
};

/**
 * get content for CL RX method (TYP)
 */
const getPopupContentData = (status: string): PopupContentItemType[] => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';
    return {
        [PRESCRIPTION_STATUS.FILL]: [
            {
                badge: 'Ships immediately',
                ctaButtonText: 'Confirm & Continue',
                description: "Upload it here. We'll verify it & ship it out ASAP",
                image: Rx,
                methodName: CL_RX_METHOD.UPLOAD,
                title: 'I have a copy of my prescription',
            },
            {
                ctaButtonText: 'Confirm & Continue',
                description: 'We’ll quickly verify your prescription with your doctor',
                image: MyAccount,
                methodName: CL_RX_METHOD.DOCTOR,
                title: 'Add your doctor details',
            },
            {
                analyticsLabel: isDesktop
                    ? 'Renew your prescription'
                    : `Renew your prescription for only $${VISIBLY_PRICE}`,
                ctaButtonText: 'Get Vision Test Link',
                isLinkButton: true,
                methodName: CL_RX_METHOD.EYE_EXAM,
                title: (
                    <>
                        Renew your prescription for only <Price>{VISIBLY_PRICE}</Price>!
                    </>
                ),
            },
        ],
        [PRESCRIPTION_STATUS.SKIP]: [
            {
                badge: 'Ships immediately',
                ctaButtonText: 'Confirm & Continue',
                description: "Upload it here. We'll verify it & ship it out ASAP",
                image: Rx,
                methodName: CL_RX_METHOD.UPLOAD,
                title: 'I have a copy of my prescription',
            },
            {
                ctaButtonText: 'Get Vision Test Link',
                description: isDesktop ? (
                    <>
                        Renew your prescription with
                        <br />
                        6-minute online vision test | only <Price>{VISIBLY_PRICE}</Price>!
                    </>
                ) : (
                    <>
                        Renew your prescription with 6-minute online vision test | only{' '}
                        <Price>{VISIBLY_PRICE}</Price>!
                    </>
                ),
                image: EyeExam,
                methodName: CL_RX_METHOD.EYE_EXAM,
                title: "I don't have a valid prescription",
            },
        ],
        [PRESCRIPTION_STATUS.VISTA]: [
            {
                ctaButtonText: 'Get Vision Test Link',
                description: 'Get prescription renewed with quick online vision test.',
                image: EyeExam,
                methodName: CL_RX_METHOD.EYE_EXAM,
                title: 'Take an online vision test',
            },
            {
                ctaButtonText: 'Confirm & Continue',
                description: 'We will ask your doctor for you to verify your prescription.',
                image: MyAccount,
                methodName: CL_RX_METHOD.DOCTOR,
                title: 'Verify with my eye doctor',
            },
        ],
    }[status];
};

/**
 * get prescription method
 */
const getPrescriptionMethod = (item: OrderDetailsItemsType) => {
    return item.prescription?.send_by === FILL_IT
        ? PRESCRIPTION_STATUS.FILL
        : PRESCRIPTION_STATUS.SKIP;
};

/**
 * gets the content for the popup
 */
export const getPopupContent = (orderItem: OrderDetailsItemsType | null, isVista: boolean) => {
    if (!orderItem) return [];
    const status = isVista ? PRESCRIPTION_STATUS.VISTA : getPrescriptionMethod(orderItem);
    return getPopupContentData(status);
};
